import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectorRef,
} from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { FormsServiceService } from '../../../api/services/forms-service.service';
import { InputTextFieldComponent } from '../input-text-field/input-text-field.component';
import { ModalRendererComponent } from '../../widgets/modal-renderer/modal-renderer.component';
import { WorkflowService } from '../../../api/services/workflow.service';
import { SseService } from '../../../api/services/sse.service';
import { IntegrationIconService } from '../../../api/services/integration-icon.service';

@Component({
  selector: 'app-checkbox-type-six',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalRendererComponent,
  ],
  templateUrl: './checkbox-type-six.component.html',
  styleUrl: './checkbox-type-six.component.css',
})
export class CheckboxTypeSixComponent {
  @Input() formGroup!: FormGroup;
  @Input() fields: any;
  @Output() handleTaskMappingDependency = new EventEmitter<{
    fieldName: string;
    tags: any[];
    selectedQuestion: any;
  }>();
  showValidationError = false;
  fieldsData: any;
  endpoint = environment.api_endpoint;
  selectedOptions: any[] = [];
  loadingCards: Set<string> = new Set();
  modalTitle: string = '';
  activeModalContext: any;
  activeComingSoonOption: any;
  workflowData: any;
  currentRecordId: any;
  currentNodeId: any;
  currentNode: any;
  recordID: any;
  nextNodes: any;
  targetWorkflowId: any;
  targetValue: any;
  workflowId: any;
  accessToken: any;
  isLoading: boolean = true;
  skeletonArray = Array.from({ length: 6 });
  private lastTaskMappingSignature = '';
  @ViewChild(ModalRendererComponent) modalRendererRef!: ModalRendererComponent;
  @Output() workflowTransition = new EventEmitter<any>();
  constructor(
    private formService: FormsServiceService,
    private workflowService: WorkflowService,
    private SseService: SseService,
    private cdr: ChangeDetectorRef,
    private integrationIconService: IntegrationIconService,
  ) {}
  ngOnInit() {
    this.getData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes['formGroup'] || changes['fields']) &&
      this.formGroup &&
      this.fields
    ) {
      this.getData();
    }
  }

  get control() {
    return this.formGroup.get(this.fields.fieldName);
  }

  private getSelectedIds(): string[] {
    const value = this.control?.value ?? [];
    return (Array.isArray(value) ? value : [value])
      .filter((item: any) => item !== null && item !== undefined && item !== '')
      .map((item: any) => item.toString());
  }

  private getSelectedTags(tagsControl: any): string[] {
    const value = tagsControl?.value ?? [];
    return (Array.isArray(value) ? value : [value]).filter(
      (item: any) => item !== null && item !== undefined && item !== '',
    );
  }

  private applySelectedIntegration(
    optionId: string,
    optionName: string,
    tagsControl: any,
  ): string[] {
    const selectedIds =
      this.fields?.fieldType === 'singleSelect'
        ? [optionId]
        : Array.from(new Set([...this.getSelectedIds(), optionId]));
    const selectedTags =
      this.fields?.fieldType === 'singleSelect'
        ? [optionName]
        : Array.from(
            new Set([...this.getSelectedTags(tagsControl), optionName]),
          );

    this.control?.setValue(selectedIds);
    tagsControl?.setValue(selectedTags);
    this.selectedOptions = [...selectedIds];
    this.emitTaskMappingDependency(selectedTags);

    this.control?.markAsTouched();
    this.control?.updateValueAndValidity();

    return selectedIds;
  }

  /** Function to get the data by api or static */
  getData() {
    this.isLoading = true;
    // if (this.fields.options.isStatic == true) {
    //   // this.fieldsData = this.fields.options.staticOptions;
    //   this.fieldsData = [
    //     {
    //       _id: '685a3c5a1c03cf18b365e050',
    //       name: 'Snipe-IT',
    //       subText: 'Open-Source IT Asset Management',
    //       category: 'Open-Source IT Asset Management',
    //       description:
    //         'Open-source web-based asset management tool ideal for IT asset tracking.',
    //       version: '',
    //       publisher: 'Grokability, Inc.',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl: 'https://snipeitapp.com',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/Snipe-IT.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'SnipeITAPI',
    //         authUrl: '{{base}}/snipe-it/oauth/start',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['open-source', 'itam', 'snipe-it'],
    //       createdAt: '',
    //       updatedAt: '',
    //       fieldDependencies: [
    //         {
    //           trigger: 'onClick',
    //           condition: [
    //             {
    //               conditions: [
    //                 {
    //                   type: 'modal',
    //                   targetType: 'workflow',
    //                   targetValue: '68c3ec9045a7a695efb493f1',
    //                 },
    //               ],
    //             },
    //           ],
    //         },
    //       ],
    //     },
    //     {
    //       _id: '685a3c5a1c03cf18b365e04e',
    //       name: 'ManageEngine Asset Explorer',
    //       subText: 'IT Asset Management',
    //       category: 'IT Asset Management',
    //       description:
    //         'Comprehensive IT asset management solution by ManageEngine for tracking and managing assets through their lifecycle.',
    //       version: '',
    //       publisher: 'ManageEngine',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl:
    //         'https://www.manageengine.com/products/asset-explorer/',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/MEAE.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'ManageEngineAPI',
    //         url: '',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['itam', 'asset management', 'manageengine'],
    //       createdAt: '',
    //       updatedAt: '',
    //     },
    //     {
    //       _id: '685a3c5a1c03cf18b365e04f',
    //       name: 'Fresh Service',
    //       subText: 'Cloud-Based IT Service Management (ITSM)',
    //       category: 'Cloud-Based IT Service Management (ITSM)',
    //       description:
    //         'ITSM solution from Freshworks offering asset management, incident tracking, and more.',
    //       version: '',
    //       publisher: 'Freshworks',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl: 'https://freshservice.com',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/FS.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'FreshserviceAPI',
    //         url: '',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['itsm', 'asset management', 'freshworks'],
    //       createdAt: '',
    //       updatedAt: '',
    //     },
    //     {
    //       _id: '685a3c5a1c03cf18b365e051',
    //       name: 'Spicework',
    //       subText: 'Asset Management and Helpdesk',
    //       category: 'Asset Management and Helpdesk',
    //       description:
    //         'Free IT management software including network monitoring, inventory, and helpdesk tools.',
    //       version: '',
    //       publisher: 'Spiceworks Inc.',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl: 'https://www.spiceworks.com',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/Spicework.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'SpiceworksAPI',
    //         url: '',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['spiceworks', 'asset management', 'helpdesk'],
    //       createdAt: '',
    //       updatedAt: '',
    //     },
    //     {
    //       _id: '685a3c5a1c03cf18b365e052',
    //       name: 'Asset Panda',
    //       subText: 'Cloud-Based Asset Management',
    //       category: 'Cloud-Based Asset Management',
    //       description:
    //         'Asset Panda offers a cloud-based platform for tracking and managing physical and digital assets.',
    //       version: '',
    //       publisher: 'Asset Panda LLC',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl: 'https://www.assetpanda.com',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/AssetPanda.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'AssetPandaAPI',
    //         url: '',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['assetpanda', 'cloud asset', 'management'],
    //       createdAt: '',
    //       updatedAt: '',
    //     },
    //     {
    //       _id: '685a3c5a1c03cf18b365e053',
    //       name: 'Invgate Asset',
    //       subText: 'IT Asset Management',
    //       category: 'IT Asset Management',
    //       description:
    //         'Comprehensive IT asset management solution providing visibility into hardware, software, and usage.',
    //       version: '',
    //       publisher: 'InvGate',
    //       region: 'Global',
    //       status: 'Active',
    //       documentationUrl: 'https://invgate.com/asset-management',
    //       iconUrl:
    //         'https://developmentcontent.blob.core.windows.net/resources/endpoint/Invgate.png',
    //       integration: {
    //         allowIntegration: true,
    //         type: 'api',
    //         apiName: 'InvgateAPI',
    //         url: '',
    //         headers: {},
    //         parameters: {},
    //       },
    //       tags: ['invgate', 'itam', 'asset tracking'],
    //       createdAt: '',
    //       updatedAt: '',
    //     },
    //   ];
    //   if (this.fields?.value?.length && this.fieldsData) {
    //     const selectedIds = this.fields.value.map((v: any) => v.toString());

    //     // Only keep those that still exist in fieldsData
    //     const validSelections = this.fieldsData
    //       .map((item: any) => item._id.toString())
    //       .filter((id: string) => selectedIds.includes(id));

    //     this.control?.setValue(validSelections, { emitEvent: false });
    //   }
    //   this.restoreTagsFromSelectedOptions();
    //   this.isLoading = false;
    // } else {
    const formId = this.fields.options.source.formID;
    const api_endpoint = this.endpoint;
    const method = this.fields.options.source.method;
    let url = this.fields.options.source.apiUrl;
    const replacements = {
      formID: formId,
      api_endpoint: api_endpoint,
    };
    url = this.formService.replaceTemplateTokens(url, replacements);
    const accessToken = localStorage.getItem('accessToken');
    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    };
    this.formService.loadData(method, url, headers).subscribe({
      next: (res) => {
        this.fieldsData = res.data.records;
        this.restoreTagsFromSelectedOptions();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.fieldsData = [];
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
    // }
  }

  restoreTagsFromSelectedOptions() {
    if (!this.fieldsData?.length) return;

    const currentValue = (this.fields?.value || []).map((v: any) =>
      v.toString(),
    );

    const selectedOptions = this.fieldsData.filter((opt: any) =>
      currentValue.includes(opt._id?.toString()),
    );

    const restoredIds = selectedOptions.map((opt: any) => opt._id.toString());
    if (JSON.stringify(currentValue) !== JSON.stringify(restoredIds)) {
      this.control?.setValue(restoredIds, { emitEvent: false });
    }

    const selectedNames = selectedOptions.map((opt: any) => opt.name);
    this.formGroup
      .get(this.fields.fieldName + 'Tags')
      ?.setValue(selectedNames, { emitEvent: false });
    this.emitTaskMappingDependency(selectedNames);
  }

  /** Function to get the selectedOptions and apply styles to them */
  // isSelected(option: any): boolean {
  //   const value = (this.control?.value || this.fields?.value || []).map(
  //     (v: any) => v.toString(),
  //   );
  //   return value.includes(option._id?.toString());
  // }

  isSelected(option: any): boolean {
    const currentValue = this.control?.value;

    if (!currentValue) return false;

    // SINGLE SELECT
    if (this.fields?.fieldType === 'singleSelect') {
      return this.getSelectedIds().includes(option._id?.toString());
    }

    // MULTI SELECT
    return this.getSelectedIds().includes(option._id?.toString());
  }

  /** Function to disable another cards  */
  isDisabled(option: any): boolean {
    if (this.fields?.fieldType !== 'singleSelect') return false;

    const rawValue = this.control?.value || this.fields?.value || [];
    const value = (Array.isArray(rawValue) ? rawValue : [rawValue]).map(
      (v: any) => v.toString(),
    );
    return value.length > 0 && !value.includes(option._id?.toString());
  }

  /** Function to toggle the card and push the selection into array */
  toggleSelection(option: any): void {
    if (option.fieldDependencies == null) {
      this.activeComingSoonOption = option;
      const modalId = `coming_soon_modal_${this.fields.fieldName}`;
      const mEl = document.getElementById(modalId);
      if (mEl) mEl.classList.add('show');
      return;
    }

    // if (this.fields?.fieldType !== 'singleSelect') return;;
    const optionId = option?._id?.toString();
    if (!optionId) return;

    const tagsControl = this.formGroup.get(`${this.fields.fieldName}Tags`);
    const currentValues = this.getSelectedIds();
    const isSelected = currentValues.includes(optionId);

    // 🔁 Deselect if already selected
    if (isSelected) {
      this.resetSelection(optionId, tagsControl);
      return;
    }

    this.loadingCards.add(optionId);

    // 🧩 Handle workflow modal dependency
    if (this.handleWorkflowModal(option)) {
      this.loadingCards.delete(optionId);
      return;
    }

    // 🔐 Handle OAuth / Integration
    this.openIntegrationAuth(option);

    // 📡 Listen for SSE success
    this.listenForConnectionSuccess(option, tagsControl);
  }

  resetSelection(optionId: string, tagsControl: any): void {
    const selectedIds = this.getSelectedIds().filter((id) => id !== optionId);
    const optionName = this.fieldsData?.find(
      (option: any) => option._id?.toString() === optionId,
    )?.name;
    const selectedTags = this.getSelectedTags(tagsControl).filter(
      (tag) => tag !== optionName,
    );

    this.control?.setValue(selectedIds);
    tagsControl?.setValue(selectedTags);
    this.selectedOptions = [...selectedIds];
    this.loadingCards.delete(optionId);
    this.emitTaskMappingDependency(selectedTags);
  }

  handleWorkflowModal(option: any): boolean {
    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = fieldDeps.find((d: any) => d.trigger === 'onClick');
    if (!onClickDep?.condition) return false;

    for (const block of onClickDep.condition) {
      const modalCond = block.conditions?.find(
        (c: any) =>
          c.type === 'modal' && c.targetType === 'workflow' && c.targetValue,
      );

      if (!modalCond) continue;

      this.activeModalContext = {
        workflowId: modalCond.targetValue,
        selectedOption: option,
        authUrl: option.integration?.authUrl,
        selectedName: option.name,
        fieldName: this.fields.fieldName,
        currentSelectedName:
          option.name == 'Cloud Computing' ? 'GCP' : option.name,
      };

      this.loadWorkflow(modalCond.targetValue, 0);

      const modal = document.getElementById(
        `connection_modal_${this.fields.fieldName}`,
      );
      modal?.classList.add('show');

      return true;
    }

    return false;
  }

  openIntegrationAuth(option: any): void {
    const authTemplate = option?.integration?.authUrl;
    if (!authTemplate) return;

    this.accessToken = localStorage.getItem('accessToken') || '';
    const catCode = option.categoryCode ||
      option.integration?.categoryCode ||
      this.fields?.displayName ||
      '';
    const recordIdVal = String(this.recordID || this.activeModalContext?.recordID || this.currentRecordId || '');
    let authUrl = authTemplate
      .replace('{{base}}', this.endpoint)
      .replace(/\{\{categoryCode\}\}/g, catCode)
      .replace(/\{\{integrationProfileRecordID\}\}/g, recordIdVal);

    const separator = authUrl.includes('?') ? '&' : '?';
    authUrl += `${separator}at=${encodeURIComponent(this.accessToken)}`;

    window.open(authUrl, '_blank');
  }

  listenForConnectionSuccess(option: any, tagsControl: any): void {
    const optionId = option._id.toString();
    const optionName = option.name;

    const sub = this.SseService.getMessages().subscribe({
      next: (msg: any) => {
        try {
          const parsed = typeof msg === 'string' ? JSON.parse(msg) : msg;

          const isSuccess =
            parsed?.type === 'connectionSuccess' ||
            parsed?.type === 'connectSuccess' ||
            parsed?.payload?.status === 200;

          if (!isSuccess) return;

          this.applySelectedIntegration(optionId, optionName, tagsControl);

          this.loadingCards.delete(optionId);
          sub.unsubscribe();
        } catch (err) {
          console.error('SSE parse error:', err);
        }
        this.cdr.detectChanges();
      },
      error: () => {
        sub.unsubscribe();
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads the workflow and optionally a specific node */
  loadWorkflow(wId: string, nodeId?: any, nodeIndex?: any): void {
    this.workflowService.loadWorkflow(wId).subscribe({
      next: ({ workflowData, recordId }) => {
        this.workflowData = workflowData;
        this.currentRecordId = recordId;
        this.workflowId = wId;
        // --- Handle second last node request ---
        if (nodeIndex === 'secondLastNode') {
          const nodes = workflowData?.nodes || [];

          if (nodes.length >= 2) {
            const secondLastNode = nodes[nodes.length - 2]; // ⭐ correct node
            this.currentNodeId = secondLastNode._id;
            this.loadNode(secondLastNode._id, recordId);
            return; // ⭐ STOP HERE, do NOT load startNodeId
          }
        }
        // --- Default start node logic ---
        const startNodeId = nodeId || workflowData?.startNodeId;
        if (startNodeId) {
          this.currentNodeId = startNodeId;
          this.loadNode(startNodeId, recordId);
        } else {
          console.warn(`[Workflow] No startNodeId found for workflow: ${wId}`);
        }
        this.cdr.detectChanges();
      },
      error: (error: any) => {
        this.cdr.detectChanges();
      },
    });
  }

  /** Loads a node and processes navigation-related metadata */
  loadNode(nodeId: string, recordId?: string): void {
    if (this.activeModalContext?.nodeId === nodeId) {
      this.currentNodeId = nodeId;
      this.currentNode = null;
      this.nextNodes = null;
      this.targetWorkflowId = null;
      this.cdr.detectChanges();
      return;
    }
    const node = this.workflowData?.nodes?.find((n: any) => n._id === nodeId);
    if (!node) {
      return;
    }

    this.currentNode = node;
    this.currentNodeId = node._id;
    const platformName =
      this.activeModalContext?.selectedOption?.platformName ||
      this.activeModalContext?.selectedName ||
      '';
    this.recordID =
      node.recordId && node.recordId.trim() !== ''
        ? node.recordId
        : recordId || platformName;
    if (
      this.currentNode?.triggers?.some(
        (trigger: any) => trigger.type === 'api' && trigger.event === 'onLoad',
      )
    ) {
      this.executeNodeTriggers();
    }
    this.cdr.detectChanges();
    const nextButtonObj =
      node.next?.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next?.[0];

    if (!nextButtonObj) return;

    const condition = nextButtonObj.condition;

    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          this.nextNodes = cond.targetValue;
          return;
        }
        if (cond?.targetNodeId) {
          this.nextNodes = cond.targetNodeId;
          return;
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          this.targetValue = cond.targetValue;
          return;
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          this.targetWorkflowId = cond.targetValue;
          return;
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        this.nextNodes = nextButtonObj.targetValue;
      } else if (nextButtonObj.targetNodeId) {
        this.nextNodes = nextButtonObj.targetNodeId;
      } else if (
        nextButtonObj.targetType === 'url' &&
        nextButtonObj.targetValue
      ) {
        this.targetValue = nextButtonObj.targetValue;
      } else if (
        nextButtonObj.targetType === 'workflow' &&
        nextButtonObj.targetValue
      ) {
        this.targetWorkflowId = nextButtonObj.targetValue;
      } else {
        console.warn(`[Workflow] No valid condition in nextButtonObj.`);
      }
    } else {
      console.warn(`[Workflow] Invalid or missing condition in node.`);
    }
  }

  executeNodeTriggers() {
    const node = this.workflowData?.nodes?.find(
      (n: any) => n._id === this.currentNodeId,
    );

    if (!node?.triggers?.length) return;

    const onLoadTrigger = node.triggers.find(
      (trigger: any) => trigger.type === 'api' && trigger.event === 'onLoad',
    );

    if (!onLoadTrigger?.api) return;

    const triggerApi = onLoadTrigger.api;

    // replace template tokens
    const url = this.formService.replaceTemplateTokens(triggerApi.url, {
      api_endpoint: this.endpoint,
      formID: triggerApi.formID,
      recordID: node.recordId || '',
    });

    this.formService
      .submitFormData(
        {
          url,
          method: triggerApi.method || 'GET',
        },
        {},
      )
      .subscribe({
        next: (res) => {
          // success
          this.handleWorkflowTransition(200);
          this.cdr.detectChanges();
        },

        error: (err) => {
          // error transition
          this.handleWorkflowTransition(err.status);
          this.cdr.detectChanges();
        },
      });
  }

  handleWorkflowTransition(status: number) {
    const node = this.workflowData?.nodes?.find(
      (n: any) => n._id === this.currentNodeId,
    );

    if (!node?.next?.length) return;

    const transitions = node.next[0].condition || [];

    for (const condition of transitions) {
      const apiCondition = condition.conditions?.find(
        (c: any) => c.type === 'api' && c.value === 'status',
      );

      if (apiCondition?.equals?.includes(status)) {
        // update active node
        this.currentNodeId = condition.targetValue;

        // persist workflow state
        this.workflowData = {
          ...this.workflowData,
          startNodeId: condition.targetValue,
        };

        // update current node
        this.currentNode = this.workflowData?.nodes?.find(
          (n: any) => n._id === condition.targetValue,
        );

        // save workflow instance
        const workflowId = this.workflowData?._id || this.workflowId;

        if (workflowId) {
          const apiUrl = `/api/v1/workflow/instances/${workflowId}`;

          this.modalRendererRef.updateInstance(
            apiUrl,
            this.workflowData,
            false,
          );
        }

        break;
      }
    }
  }

  /** Function to validate the card is selected or not then show error message */
  validateSelection(): boolean {
    const currentValue = (this.control?.value || []).map((v: any) =>
      v.toString(),
    );
    if (currentValue.length > 0) {
      this.showValidationError = false;
      return true;
    }
    if (this.fields.isRequired) {
      this.showValidationError = true;
      return false;
    }
    this.showValidationError = false;
    return true;
  }

  openConnect(option: any, id: string) {
    const fieldDeps = option?.fieldDependencies || [];
    const onClickDep = fieldDeps.find((dep: any) => dep.trigger === 'onClick');

    if (onClickDep && Array.isArray(onClickDep.condition)) {
      for (const condBlock of onClickDep.condition) {
        const modalCond = condBlock.conditions?.find(
          (c: any) =>
            c.type === 'modal' && c.targetType === 'workflow' && c.targetValue,
        );

        if (modalCond) {
          // --- Set modal context for <app-modal-renderer> ---
          this.activeModalContext = {
            workflowId: modalCond.targetValue,
            selectedOption: option,
            selectedName: option.name,
            authUrl: option.integration?.authUrl || null,
            recordID: this.recordID,
            workflowData: this.workflowData,
          };

          // --- Load the workflow for modal renderer ---
          this.loadWorkflow(
            this.activeModalContext.workflowId,
            0,
            'secondLastNode',
          );

          // --- Open the modal (specific to fieldName) ---
          const modalId = `connection_modal_${this.fields.fieldName}`;
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.classList.add('show');
          }
          this.cdr.detectChanges();
          return;
        }
      }
    }
  }

  closeOnBackdropClick(event: MouseEvent, modalId: string) {
    const modal = document.getElementById(modalId);
    if (event.target === modal) {
      this.closeModal(modalId);
    }
  }

  closeModal(modalId: string) {
    const modal = document.getElementById(modalId);
    if (modal) modal.classList.remove('show');
    this.activeModalContext = null;
    this.activeComingSoonOption = null;
    this.stopPollingFromModalRenderer();
    this.currentNodeId = null;
    this.currentNode = null;
    this.workflowData = null;
    this.recordID = null;
    this.workflowId = null;
    this.currentRecordId = null;
    this.modalTitle = '';
    this.cdr.detectChanges();
  }

  stopPollingFromModalRenderer() {
    if (this.modalRendererRef) {
      this.modalRendererRef.stopChildPolling();
    }
  }

  onModalFormSaved(event: any): void {
    const optionId = this.activeModalContext?.selectedOption?._id;
    const tagsControl = this.formGroup.get(this.fields.fieldName + 'Tags');

    if (event?.success) {
      const savedRecordId = event.recordId || event._id || event?.data?._id;
      if (savedRecordId) {
        this.recordID = savedRecordId;
        if (this.activeModalContext) {
          this.activeModalContext.recordID = savedRecordId;
        }
        if (this.currentNode) {
          this.currentNode.recordId = savedRecordId;
        }
        const savedNode = this.workflowData?.nodes?.find(
          (n: any) => n._id === (event.formId || this.currentNodeId || this.currentNode?._id),
        );
        if (savedNode) {
          savedNode.recordId = savedRecordId;
        }
      }
      const option = this.activeModalContext?.selectedOption;
      if (option && option.name) {
        console.log(`✅ Connection completed for: ${option.name}`);
      }

      const { nextNodeId, targetValue, targetWorkflowId, isSseTrigger } =
        this.resolveNavigationTargets(this.currentNode);

      const currentIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === this.currentNode?._id,
      );
      const lastNode = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === nextNodeId,
      );
      const lastNodeIndex = this.workflowData?.nodes?.length - 1;
      const nextNodeIndex = this.workflowData?.nodes?.findIndex(
        (n: any) => n._id === nextNodeId,
      );
      const isLastNode = currentIndex === lastNodeIndex;
      const isSecondOrThirdNode =
        currentIndex === 1 ||
        currentIndex === 2 ||
        currentIndex == lastNodeIndex;
      const isNextNodeTheLastNode = nextNodeIndex === lastNodeIndex;

      // 🔥 NEW: Mark selected when NEXT NODE is the LAST node
      if (isNextNodeTheLastNode && !isLastNode) {
        const newValue = this.applySelectedIntegration(
          this.activeModalContext?.selectedOption?._id?.toString(),
          this.activeModalContext?.selectedOption?.name,
          tagsControl,
        );

        this.currentNode.selectedOptions = newValue;
        this.workflowData.selectedOptions = newValue;

        this.loadingCards.delete(optionId);
        this.cdr.detectChanges();
      }

      // ✅ When reaching last node
      if (isLastNode) {
        this.applySelectedIntegration(
          this.activeModalContext?.selectedOption?._id?.toString(),
          this.activeModalContext?.selectedOption?.name,
          tagsControl,
        );

        this.loadingCards.delete(optionId);
        this.currentNode.selectedOptions = this.selectedOptions;
        this.workflowData.selectedOptions = this.selectedOptions;
        this.cdr.detectChanges();
      }

      // ✅ Handle workflow transitions
      if (nextNodeId && !isSseTrigger) {
        this.loadNode(nextNodeId, savedRecordId || event?.recordId);
        this.cdr.detectChanges();
        return;
      }

      if (targetValue) {
        const token = localStorage.getItem('accessToken');
        if (token) {
          window.location.href = `${targetValue}/${token}`;
          return;
        }
      }

      if (targetWorkflowId) {
        this.loadWorkflow(targetWorkflowId);
        this.cdr.detectChanges();
        return;
      }

      // 🔁 SSE Trigger
      if (isSseTrigger) {
        const sseTrigger = this.currentNode?.triggers?.find(
          (trigger: any) => trigger.event === 'listenSSE',
        );
        if (sseTrigger?.config?.url && sseTrigger?.config?.nextNodeId) {
          const apiEndpoint = environment.api_endpoint;
          const authToken = localStorage.getItem('accessToken') || '';
          const resolvedUrl = sseTrigger.config.url
            .replace('{{api_endpoint}}', apiEndpoint)
            .replace('{{authToken}}', authToken);

          // this.SseService.initSSE(resolvedUrl);
          this.loadNode(sseTrigger.config.nextNodeId, savedRecordId || event?.recordId);
          this.cdr.detectChanges();
          return;
        }
      }

      // ✅ Close modal properly
      const modalId = `connection_modal_${this.fields.fieldName}`;
      this.closeModal(modalId);
      this.cdr.detectChanges();
    }
  }

  /** Resolves navigation targets from current node */
  resolveNavigationTargets(node: any): {
    nextNodeId: string | null;
    targetValue: string | null;
    targetWorkflowId: string | null;
    recordId: string | null;
    isSseTrigger?: boolean;
  } {
    const fallback = {
      nextNodeId: null,
      targetValue: null,
      targetWorkflowId: null,
      recordId: node?.recordId ?? null,
      isSseTrigger: false,
    };

    if (!node?.next || !Array.isArray(node.next)) return fallback;

    const nextButtonObj =
      node.next.find((n: any) =>
        ['next_button', 'submit_continue'].includes(n.buttonId),
      ) || node.next[0];

    if (!nextButtonObj) return fallback;

    const resolveSseTrigger = (): {
      nextNodeId: string | null;
      isSseTrigger: boolean;
    } => {
      const sseTrigger = node.triggers?.find(
        (trigger: any) => trigger.event === 'listenSSE',
      );
      if (sseTrigger?.config?.nextNodeId) {
        return { nextNodeId: sseTrigger.config.nextNodeId, isSseTrigger: true };
      }
      return { nextNodeId: null, isSseTrigger: false };
    };

    const condition = nextButtonObj.condition;

    if (Array.isArray(condition)) {
      for (const cond of condition) {
        if (cond?.targetType === 'node' && cond?.targetValue) {
          return { ...fallback, nextNodeId: cond.targetValue };
        }
        if (cond?.targetNodeId) {
          return { ...fallback, nextNodeId: cond.targetNodeId };
        }
        if (cond?.targetType === 'url' && cond?.targetValue) {
          return { ...fallback, targetValue: cond.targetValue };
        }
        if (cond?.targetType === 'workflow' && cond?.targetValue) {
          return { ...fallback, targetWorkflowId: cond.targetValue };
        }
        if (cond?.targetType === 'manual') {
          const { nextNodeId, isSseTrigger } = resolveSseTrigger();
          if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
        }
      }
    } else if (typeof condition === 'object' && condition !== null) {
      if (nextButtonObj.targetType === 'node' && nextButtonObj.targetValue) {
        return { ...fallback, nextNodeId: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetNodeId) {
        return { ...fallback, nextNodeId: nextButtonObj.targetNodeId };
      }
      if (nextButtonObj.targetType === 'url' && nextButtonObj.targetValue) {
        return { ...fallback, targetValue: nextButtonObj.targetValue };
      }
      if (nextButtonObj.targetType === 'manual') {
        const { nextNodeId, isSseTrigger } = resolveSseTrigger();
        if (nextNodeId) return { ...fallback, nextNodeId, isSseTrigger };
      }
    }
    return fallback;
  }

  /** Function to set the modal title */
  setModalTitle(title: string) {
    this.modalTitle = title;
  }

  checkPollingServiceForError(value: any) {
    // 🔍 Find the "attempts" condition in the current node’s next array
    const attemptNode = this.currentNode?.next?.find((next: any) =>
      next.condition.some((condGroup: any) =>
        condGroup.conditions.some((cond: any) => cond.type === 'attempts'),
      ),
    );

    if (attemptNode) {
      const targetNodeId = attemptNode?.condition?.[0]?.targetValue;
      const targetType = attemptNode?.condition?.[0]?.targetType;
      if (targetType === 'node' && targetNodeId) {
        this.loadNode(targetNodeId);
      } else if (targetType === 'workflow' && targetNodeId) {
        this.loadWorkflow(targetNodeId);
      } else {
        console.warn('⚠️ No valid target found for attempts condition');
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey() {
    if (this.fields?.fieldName) {
      this.closeModal('connection_modal_' + this.fields.fieldName);
      this.closeModal('coming_soon_modal_' + this.fields.fieldName);
    }
  }

  private emitTaskMappingDependency(tags: any[]) {
    const normalizedTags = Array.isArray(tags) ? tags : [];
    const signature = normalizedTags.join('|');

    if (signature === this.lastTaskMappingSignature) {
      return;
    }

    this.lastTaskMappingSignature = signature;
    this.handleTaskMappingDependency.emit({
      fieldName: this.fields?.fieldName,
      tags: normalizedTags,
      selectedQuestion: this.fields?.displayName || '',
    });
  }

  onCardClick(option: any): void {
    // if (this.isDisabled(option)) {
    //   return;
    // }

    this.toggleSelection(option);
  }

  handleImageError(option: any, event: Event) {
    this.integrationIconService.handleImageError(option, event);
  }
}
